
import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel'
import VehicleCategoryModel from '@/models/VehicleCategoryModel'
import ColorModel from '@/models/ColorModel'
import ShowroomModel from '@/models/ShowroomModel'
export default class CarForSellModel extends BaseModel {

    constructor() {
        super({
                name: "car_for_sell",
                tableName: 'car_for_sell',
                label: "Car For Sell"
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                avatar: {
                    name: "avatar",
                    label: "Image",
                    custom: 'image',
                    type: "Computed",
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    width: 3,
                    class : 'left'
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Car code',
                    filter: {type: 'input', match: 'contains'},
                    class : 'left',

                    // sortable: false,
                    width: 8,
                },
                plate_number: {
                    name: 'plate_number',
                    type: "String",
                    label: 'Licensen plate number',
                    filter: {type: 'input', match: 'contains'},

                    // sortable: false,
                    class : 'left',

                    width: 15,
                },
                make_vehicle_category_id: {
                    name: "make_vehicle_category_id",
                    label: "Make",
                    type: "Computed",
                    models: new VehicleCategoryModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },

                    computed: (data) => {
                        data.make_vehicle_category_id ='' ;
                    },
                    class:"left",
                    width : 8,
                },

                color_id_key: {
                    name: "updated_by_key",
                    label: "Color",
                    type: "Computed",
                    models: new ColorModel(),
                    filter: {type: 'input', match: 'contains'},

                    computed: (data) => {
                        data.color_id_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
       
                build: {
                    name: 'build',
                    type: "custom",
                    label: 'Build',
                    width: 15,
                    filter: { type: 'Date', match: 'equals' },
                    class : 'left'
                },


       
                showroom_id: {
                    name:'showroom_id',
                    label:'Showroom',
                    type: "Computed",
                    models: new ShowroomModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    class : 'left',
                    computed: (data) => {
                        data.showroom_id = '';
                    },
                    width : 8,
                },
                // no visit
                visit: {
                    name: "visit",
                    label: "No. of visit",
                    type: "Computed",
                    computed: (data) => {
                        data.visit ='' ;
                    },
                    class : 'left',
                    width : 10,
                },
                status: {
                    name: "status",
                    label: "Status",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'FOR_SELL', label: 'FOR SELL'},
                        {value: 'SOLD_OUT_SELL', label: 'SOLD OUT'},
                        {value: 'CANCEL_SELL', label: 'CANCEL'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class : 'left',
                    width : 5,
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class : 'center',
                    width : 5,
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    // filter: {type: 'input', match: 'contains'},
                    models: new UserModel(),
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_at: {
                    name: 'updated_at',
                    type: "String",
                    label: 'Updated date',
                    width: 8,
                    class:"left",

                },
                detail_get: {
                    refs:  'alt rental_order_sell_arr { id rental_order_id rental_order { id code booking_status }}  obj_colour { id name } obj_showroom { id name  }  obj_updated_by { id fullname }  obj_vehicle_category { id name bond_fee} rental_order_buy { id  rental_order { id  code    } }  ',
                    display: false
                },
                detail_get1: {
                    refs:  ' finance_id name price_before price showroom_id make_vehicle_category_id model color_id type odometer fuel_type_id battery_capacity transmission_id  rego_validation url_video description new active auto_in_number ',
                    display: false
                },
            })
    }

}